import { fetchWrapper, objectToQueryParams } from '../utils';

const baseUrl = process.env.REACT_APP_BASE_API + 'general';

export const saveIP = async (code) => {
  const url = `${baseUrl}/check-referral/${code}`;
  return await fetchWrapper.get(url);
}

export const findPaymentFrequencies = async (filters) => {
  const url = `${baseUrl}/payment-frequencies?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getBanks = async () => {
  const url = `${baseUrl}/banks`;
  return await fetchWrapper.get(url);
}

export const getBanksOTP = async (filters) => {
  const url = `${baseUrl}/syspago/banksotp`;
  return await fetchWrapper.post(url, filters);
}

export const getBNCBanksOTP = async (filters) => {
  const url = `${baseUrl}/bnc/banksotp`;
  return await fetchWrapper.post(url, filters);
}

export const getConversion = async () => {
  const url = `${baseUrl}/conversion`;
  return await fetchWrapper.get(url);
}

export const getDocumentTypes = async () => {
  const url = `${baseUrl}/document-types`;
  return await fetchWrapper.get(url);
}

export const getGenders = async () => {
  const url = `${baseUrl}/genders`;
  return await fetchWrapper.get(url);
}

export const getPaymentMethods = async () => {
  const url = `${baseUrl}/payment-methods`;
  return await fetchWrapper.get(url);
}

export const getPaymentMethodInfo = async (id) => {
  const url = `${baseUrl}/payment-method-info/${id}`;
  return await fetchWrapper.get(url);
}

export const getPhoneCodes = async () => {
  const url = `${baseUrl}/phone-codes`;
  return await fetchWrapper.get(url);
}

export const getQuestions = async () => {
  const url = `${baseUrl}/questions`;
  return await fetchWrapper.get(url);
}

export const getRelationships = async () => {
  const url = `${baseUrl}/relationships`;
  return await fetchWrapper.get(url);
}

export const getStates = async () => {
  const url = `${baseUrl}/states`;
  return await fetchWrapper.get(url);
}

export const getTownships = async (filters) => {
  const url = `${baseUrl}/townships?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getParishes = async (filters) => {
  const url = `${baseUrl}/parishes?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const acxelCallApi = async (form) => {
  const url = `${baseUrl}/acxel-api`;
  return await fetchWrapper.post(url, form);
}

export const saveIdepol = async (form) => {
  const url = `${baseUrl}/saveidepol`;
  return await fetchWrapper.post(url, form);
}

export const getContactPhone = async () => {
  const url = `${baseUrl}/contact-phone`;
  return await fetchWrapper.get(url);
}